/**
 * Maps icon names stored in the DB (kebab-case or PascalCase) to lucide-react components.
 * Used by Header (dynamic menu) and the /admin/menu-builder preview.
 *
 * Add new mappings here when a new icon name appears in the DB.
 */
import {
  Monitor, Tag, Tv, Users, Plane, Scale, LayoutDashboard, BarChart3, Gauge,
  Briefcase, RefreshCw, Database, ShoppingCart, ShoppingBag, Headphones, Rocket,
  CreditCard, Wrench, MapPin, Server, Printer, Scan, Cpu, Search, BatteryCharging,
  Zap, ShieldCheck, Clock, Handshake, Award, Newspaper, DoorOpen, HardHat, Hammer,
  Smartphone, Shrimp, Package, Calculator, Activity, Sparkles, Box, Boxes,
  Building2, Layers, Eye, Wifi, Bot, MessageSquare,
} from 'lucide-react';

const ICON_MAP = {
  // hw_categories DB icons (kebab-case)
  'monitor': Monitor,
  'credit-card': CreditCard,
  'search': Search,
  'scale': Scale,
  'tag': Tag,
  'tv': Tv,
  'plane': Plane,
  'battery-charging': BatteryCharging,
  'printer': Printer,
  'scan': Scan,
  'smartphone': Smartphone,
  'cpu': Cpu,
  'refresh-cw': RefreshCw,
  'server': Server,
  'package': Package,
  'box': Box,
  'boxes': Boxes,
  // solutions DB icons
  'shopping-bag': ShoppingBag,
  'shopping-cart': ShoppingCart,
  'users': Users,
  'door-open': DoorOpen,
  // misc
  'briefcase': Briefcase,
  'layout-dashboard': LayoutDashboard,
  'bar-chart-3': BarChart3,
  'gauge': Gauge,
  'database': Database,
  'headphones': Headphones,
  'rocket': Rocket,
  'wrench': Wrench,
  'map-pin': MapPin,
  'zap': Zap,
  'shield-check': ShieldCheck,
  'clock': Clock,
  'handshake': Handshake,
  'award': Award,
  'newspaper': Newspaper,
  'hard-hat': HardHat,
  'hammer': Hammer,
  'shrimp': Shrimp,
  'calculator': Calculator,
  'activity': Activity,
  'sparkles': Sparkles,
  'building-2': Building2,
  'layers': Layers,
  'eye': Eye,
  'wifi': Wifi,
  'bot': Bot,
  'message-square': MessageSquare,
};

/** Resolve a string icon name (kebab-case or PascalCase) to a lucide component. */
export const resolveIcon = (name, fallback = Package) => {
  if (!name || typeof name !== 'string') return fallback;
  const key = name.trim().toLowerCase().replace(/_/g, '-');
  return ICON_MAP[key] || fallback;
};

/** List of valid icon names — exported for admin pickers. */
export const ICON_NAMES = Object.keys(ICON_MAP).sort();
